/**
 * File lightbox.js
 * Adds lightbox to WordPress gallery blocks.
 */

import FsLightbox from 'fslightbox';

if (typeof refreshFsLightbox === "function") {

    document.querySelectorAll('.wp-block-gallery img').forEach((image) => {

        let src;
        if (image.hasAttribute("srcset")) {
            const srcset = image.getAttribute("srcset").split(", ");
            src = srcset[srcset.length - 1].split(" ")[0];
        } else {
            src = image.getAttribute("src");
        }

        const a = document.createElement("a");
        a.setAttribute("href", src);
        a.setAttribute("data-fslightbox", "galerija");

        image.parentNode.insertBefore(a, image);
        a.appendChild(image);
    });

    refreshFsLightbox();
}